
export function sortWorkingHours(list: any) {
  return list.sort((a, b) => {
    if (a.manufacturingOrder &&
        b.manufacturingOrder &&
        a.manufacturingOrder.code &&
        b.manufacturingOrder.code &&
        a.manufacturingOrder.projectNumber &&
        b.manufacturingOrder.projectNumber) {
      // tslint:disable-next-line: radix
      return parseInt(a.manufacturingOrder.code) - parseInt(b.manufacturingOrder.code) ||
        a.manufacturingOrder.projectNumber.localeCompare(b.manufacturingOrder.projectNumber);
    }
  });
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/utils/working-hour.utils.ts